
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

interface ConfirmAction {
  key?: string;
  label: string;
}

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  standalone: true,
  imports: [ 
    MatDialogModule, 
    MatButtonModule, 
    MatCheckboxModule,
    CommonModule,
    FormsModule, 
    ReactiveFormsModule, 
    MatSelectModule,
    DragDropModule,
    MatIconModule]
})
export class ConfirmComponent implements OnInit {
  title: string;
  message: string;
  dismissLabel: string;
  actionsLabel: string;
  actionChoice?: ConfirmAction;
  isDismissOnly: boolean = false;
  showDontAskAgain: boolean = false;
  dontAskAgain: boolean = false;
  private defaultConfirm = { label: "Confirm" };
  actions: ConfirmAction[] = [ this.defaultConfirm ];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmComponent>,
  ) {
    this.title = data?.title ?? "Confirm";
    this.actionsLabel = data?.actionsLabel;
    this.dismissLabel = data?.dismissLabel ?? "Cancel";
    this.isDismissOnly = data?.isDismissOnly;
    this.showDontAskAgain = data?.showDontAskAgain;
    this.message = data?.message;
    this.actions = data?.actions ?? this.actions;
  }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    if (this.actionChoice) this.dialogRef.close({confirm: true, actionChoice: this.actionChoice});
    else if (this.showDontAskAgain) this.dialogRef.close({ confirm: true, dontAskAgain: this.dontAskAgain});
    else this.dialogRef.close(true);
  }

  invokeAction(action: ConfirmAction) {
    action == this.defaultConfirm ? this.dialogRef.close(true) : this.dialogRef.close(action)
  }
}
